module.exports = __webpack_public_path__ + "static/img/easily-customize-our-ready-made-documents.2976f80.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/policy-manual-wizard/easily-customize-our-ready-made-documents.png
// module id = 797h
// module chunks = 0